module.exports = __webpack_public_path__ + "img/7378707.png";